import { Navigate, useLocation } from "react-router-dom";

/* /autopilot ist in die Social-Seite gewandert (Stufe 2) – alte Links bleiben gültig. */
export default function AutopilotPage() {
  const { search } = useLocation();
  return <Navigate to={`/social${search}#autopilot`} replace />;
}
